import { Injectable } from '@angular/core';
import { BehaviorSubject} from 'rxjs';
import { DEFAULT_CURRENCY_CODE } from '../constants';

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {

    CURRENCY_CODE = new BehaviorSubject<string>(DEFAULT_CURRENCY_CODE);

    getCurrencyCode(): string {
        return this.CURRENCY_CODE.getValue();
    } // getCurrencyCode()

    setCurrencyCode(code: string): void {
        this.CURRENCY_CODE.next(code);
    } // setCurrencyCode()

}
